import { useQuery } from '@tanstack/react-query'
import AnalyticsApi from '@/infrastructure/api/analytics'
import { useAnalyticsScope } from '@/hooks'

function getQueryKey(
  ecommerceIds: string[],
  productId?: string,
  startDate?: string,
  endDate?: string,
  countries?: string[],
  collections?: string[]
) {
  return [
    'productDetails',
    productId,
    ecommerceIds,
    startDate,
    endDate,
    countries,
    collections
  ]
}

export function useProductDetails(
  productId?: string,
  startDate?: string,
  endDate?: string,
  countries?: string[]
) {
  const { ecommerceIds } = useAnalyticsScope()

  async function callProductDetails() {
    if (!ecommerceIds.length) return
    return AnalyticsApi.getProductDetails({
      productId,
      ecommerceId: ecommerceIds[0],
      ecommerceIds,
      startDate,
      endDate,
      countries
    })
  }

  const periodReturnRateQuery = useQuery({
    queryKey: getQueryKey(
      ecommerceIds,
      productId,
      startDate,
      endDate,
      countries
    ),
    queryFn: callProductDetails,
    staleTime: 1000 * 60 * 15,
    retry: 0,
    enabled:
      ecommerceIds.length > 0 &&
      !!productId &&
      !!startDate &&
      !!endDate &&
      countries !== undefined
  })

  const totalReturnedCount = periodReturnRateQuery.data?.reasons.reduce(
    (acc, reason) => acc + reason.totalReturnedItems,
    0
  )

  return {
    productDetails: periodReturnRateQuery.data,
    totalReturnedCount,
    loading: periodReturnRateQuery.isLoading
  }
}
